import { Box, Typography } from "@mui/material";
import Spinner from "./Spinner";

export default ({ label }: { label: string }) => (
  <Box
    role="status"
    aria-label={label}
    sx={{
      position: "absolute",
      bottom: "16px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "8px 12px",
      borderRadius: "100px",
      backgroundColor: "rgba(255, 255, 255, 0.92)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
    }}
  >
    <Spinner size={20} />
    <Typography variant="bodySmall" color="text.secondary">
      {label}
    </Typography>
  </Box>
);
